import {
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';

import { get } from '../../utils/request';
import { FETCH_FAQ } from './constants';
import { fetchFaqFailure, fetchFaqSuccess } from './actions';
import { selectServiceErrorMessage } from './selectors';

export function* fetchFaqSaga({ baseUrl }, { payload: { loanNumber } }) {
  try {
    const { faqCategories } = yield call(
      get,
      `${baseUrl}/faqs/${loanNumber}`,
    );
    yield put(fetchFaqSuccess(faqCategories));
  } catch {
    const serviceErrorMessage = yield select(selectServiceErrorMessage());
    yield put(fetchFaqFailure(serviceErrorMessage));
  }
}

export default (options) => function* rootSaga() {
  yield all([takeLatest(FETCH_FAQ, fetchFaqSaga, options)]);
};
